import React, { useState } from 'react';
import { Image, Platform, StyleSheet, TouchableOpacity, View } from 'react-native';

import Layout from '../constants/Layout';
import Colors from '../constants/Colors';
import Languages from '../constants/Languages';
import Svg from '../components/Svg';
import { useLocalization } from '../store/utils/useLocalization';

import { AppText } from '../components/AppText';

const styles = StyleSheet.create({
  container: {
    height: Layout.topMenuHeight,
    backgroundColor: Colors.primaryColor,
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: 5,
  },
  logoContainer: {
    marginLeft: 24,
    justifyContent: 'center',
  },
  logo: {
    width: 190,
    height: 45,
  },
  menuContainer: {
    flexDirection: 'row',
  },
  dropDownContainer: {
    marginRight: 16,
    width: 300,
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  menuButton: {
    marginTop: 26,
    marginHorizontal: 12,
  },
  text: {
    color: Colors.white,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  underline: {
    marginTop: 7,
    height: 2,
    width: '100%',
    backgroundColor: Colors.white,
  },
  nameAndCaret: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerDropDownContainer: {
    padding: 24,
    paddingBottom: 30,
  },
  openDropDownContainer: {
    zIndex: 1,
    backgroundColor: Colors.primaryColor,
    padding: 24,
    paddingBottom: 30,
  },
  caretContainer: {
    marginLeft: 16,
    marginTop: -8,
  },
});

export default function TopMenu(props) {
  const { actions, navigation, page, registration } = props;
  const { translation } = useLocalization();
  const { user } = registration;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  if (Platform.OS !== 'web') return null;
  if (Layout.usePantryTabs) return null;
  if (window.location !== window.parent.location) {
    return null;
  }

  const labels = {
    pantries: translation.fragment_main_bottombar_pantries,
    visits: translation.fragment_main_bottombar_visits,
    updates: translation.updates,
    profile: translation.fragment_profile_textview_title,
    Language: translation.sign_in,
    logout: translation.app_button_logout,
  };

  const button = (name) => (
    <TouchableOpacity
      key={`button-${name}`}
      onPress={() => {
        setDropdownOpen(false);
        navigation.navigate(name);
      }}
      style={styles.menuButton}
    >
      <AppText style={styles.text}>{labels[name]}</AppText>
      {page === name ? <View style={styles.underline} /> : null}
    </TouchableOpacity>
  );

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const onChangeLanguage = (langIndex) => {
    actions.selectLanguage(langIndex);
    setDropdownOpen(false);
  };

  let dropDownLabelText = '';
  if (user && user.id) {
    dropDownLabelText = `${user.first_name} ${user.last_name}`;
  } else {
    dropDownLabelText = registration.language.label || Languages.languages[0].label;
  }
  const dropDownLabel = (
    <TouchableOpacity style={styles.nameAndCaret} onPress={toggleDropdown}>
      <AppText style={styles.text}>{dropDownLabelText}</AppText>
      <View style={styles.caretContainer}>
        <Svg icon="caret_down" width={14} height={9} color={Colors.white} />
      </View>
    </TouchableOpacity>
  );

  let dropDownItems = [];
  if (user && user.id) {
    dropDownItems.push(
      <TouchableOpacity
        key="dd-profile"
        onPress={() => {
          setDropdownOpen(false);
          navigation.navigate('profile');
        }}
        style={styles.menuButton}
      >
        <AppText style={styles.text}>{labels.profile}</AppText>
      </TouchableOpacity>
    );
    dropDownItems.push(
      <TouchableOpacity
        key="dd-language"
        onPress={() => {
          setDropdownOpen(false);
          actions.logout(() => {
            if (Platform.OS === 'web') {
              window.location.href = '/language';
            } else {
              navigation.navigate('Language');
            }
          });
        }}
        style={styles.menuButton}
      >
        <AppText style={styles.text}>{labels.logout}</AppText>
      </TouchableOpacity>
    );
  } else {
    Languages.languages.forEach((lang, index) => {
      const onCheck = () => {
        onChangeLanguage(index);
      };
      dropDownItems.push(
        <TouchableOpacity
          key={lang.name}
          style={styles.menuButton}
          onPress={onCheck}
          testID={`language-${lang.name}`}
        >
          <AppText style={styles.text}>{lang.label}</AppText>
        </TouchableOpacity>
      );
    });
  }

  const menuItems = [button('pantries')];
  if (user && user.id) {
    menuItems.push(button('visits'));
    menuItems.push(button('updates'));
  } else {
    menuItems.push(button('Language'));
  }

  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Image
          source={require('../assets/images/plentiful_logo_and_label_new.png')}
          resizeMode="cover"
          style={styles.logo}
        />
      </View>
      <View style={styles.menuContainer}>{menuItems}</View>
      <View style={styles.dropDownContainer}>
        {dropdownOpen ? (
          <View style={styles.openDropDownContainer}>
            {dropDownLabel}
            {dropDownItems}
          </View>
        ) : (
          <View style={styles.innerDropDownContainer}>{dropDownLabel}</View>
        )}
      </View>
    </View>
  );
}
